import env from '@shared/config';

import { Turnstile as ReactTurnstile } from '@marsidev/react-turnstile';

interface TurnstileProps {
  onTokenChange?: (token: string | null) => void;
  theme?: 'light' | 'dark' | 'auto';
}

export const Turnstile: React.FC<TurnstileProps> = ({ onTokenChange, theme }) => {
  // Implementation of callbacks for server-side validation
  // https://developers.cloudflare.com/turnstile/get-started/server-side-validation/
  const handleSuccess = (turnstileToken: string) => {
    onTokenChange?.(turnstileToken);
  };

  const handleReset = () => {
    onTokenChange?.(null);
  };

  if (!env.CLOUDFLARE_TURNSTILE_SITE_KEY) return null;

  return (
    <ReactTurnstile
      options={{
        theme: theme ?? 'auto', // Default to light theme if not provided
      }}
      siteKey={env.CLOUDFLARE_TURNSTILE_SITE_KEY}
      onSuccess={handleSuccess}
      onExpire={handleReset}
      onError={handleReset}
    />
  );
};
